import { useState, useEffect, useCallback } from 'react'
import { Button, ButtonGroup } from 'reactstrap'

type GroupRadioButtonItem = {
  id: string
  label: string
}

export type Props = {
  items: GroupRadioButtonItem[]
  initSelectedId?: string
  onChange: (selectedId: string) => void
}

const GroupRadioButton = ({ items, initSelectedId = '', onChange }: Props) => {
  const [selectedId, setSelectedId] = useState(initSelectedId)

  useEffect(() => {
    setSelectedId(prev => prev || items[0].id)
  }, [items])

  const onChangeToggle = useCallback(
    (id: string) => {
      setSelectedId(id)
      onChange(id)
    },
    [onChange]
  )

  return (
    <ButtonGroup>
      {items.map((item: GroupRadioButtonItem) => {
        return (
          <Button
            key={`groupRadioButton-${item.id}`}
            color="primary"
            outline
            onClick={() => onChangeToggle(item.id)}
            active={selectedId === item.id}
          >
            {item.label}
          </Button>
        )
      })}
    </ButtonGroup>
  )
}

export default GroupRadioButton
